/* Erasing progress is the one irreversible action on the page, so it asks
   first — inside the rail, where the button that opened it lives. */
import { useTranslation } from 'react-i18next';
import { useApp } from '../../state/AppProvider';

export function ResetConfirm() {
  const { t } = useTranslation();
  const { resetConfirm, resetProgress } = useApp();

  return (
    <div className="panel-body">
      <p className="h3">{t('resetAsk')}</p>
      <div className="row">
        <button type="button" className="btn btn-secondary" data-act="reset-yes" onClick={resetProgress}>
          {t('yes')}
        </button>
        <button type="button" className="btn btn-ghost" data-act="reset-no" onClick={resetConfirm.cancel}>
          {t('no')}
        </button>
      </div>
    </div>
  );
}
